module.exports = __webpack_public_path__ + "img/zimimizao.041bfaa8.jpg";